import { useUI } from "../../lib/store";
import { ChatPanel } from "../chat/ChatPanel";
import { ActivityViewer } from "../logs/ActivityViewer";
import { LoopActivityPanel } from "../loops/LoopActivityPanel";
import { cn } from "../../lib/cn";

type Mode = "activity" | "chat" | "loops";

const TABS: { id: Mode; label: string }[] = [
  { id: "activity", label: "Activity" },
  { id: "chat", label: "Chat" },
  { id: "loops", label: "Loops" },
];

export function RightPane() {
  const mode = useUI((s) => s.rightPaneMode);
  const setMode = useUI((s) => s.setRightPaneMode);

  return (
    <div className="flex-1 flex flex-col overflow-hidden bg-bg-panel">
      <div className="px-3 pt-2 pb-2 bg-bg-panel">
        <Segmented mode={mode} onChange={setMode} />
      </div>
      {mode === "activity" && <ActivityViewer />}
      {mode === "chat" && <ChatPanel />}
      {mode === "loops" && <LoopActivityPanel />}
    </div>
  );
}

function Segmented({
  mode,
  onChange,
}: {
  mode: Mode;
  onChange: (m: Mode) => void;
}) {
  return (
    <div
      role="tablist"
      aria-label="Right pane mode"
      className="flex items-center gap-4 border-b border-border-subtle px-1"
    >
      {TABS.map((t) => {
        const on = t.id === mode;
        return (
          <button
            key={t.id}
            role="tab"
            aria-selected={on}
            onClick={() => onChange(t.id)}
            className={cn(
              "relative h-8 px-0.5 text-small bg-transparent transition-colors duration-fast ease-out",
              on
                ? "text-text-primary"
                : "text-text-tertiary hover:text-text-primary",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-1 focus-visible:ring-offset-bg-panel",
            )}
          >
            <span>{t.label}</span>
            {on && (
              <span
                aria-hidden="true"
                className="absolute -bottom-px left-0 right-0 h-[2px] bg-accent rounded-full"
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
